import api from '@/services/api';
import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
  }),

  actions: {
    initialized() {
      const saved = localStorage.getItem('rn573_access_token');
      if (saved) {
        return true;
      }

      return false;
    },

    getUserData() {
      return this.user;
    },

    isAdmin() {
      // Verifica se o usuário é administrador através do localStorage
      const isAdminFromStorage = localStorage.getItem('rn573_bool');

      // Verifica também através do objeto user se disponível
      const isAdminFromUser = this.user?.administrador;

      // Retorna true se qualquer uma das verificações for verdadeira
      return isAdminFromStorage == '1' || isAdminFromUser == 1;
    },

    async login(usuario, senha) {
      const res = await api.post("auth/login", { usuario, senha });
      localStorage.setItem("rn573_access_token", res.data.access_token);
      localStorage.setItem("rn573_refresh_token", res.data.refresh_token);
      localStorage.setItem("rn573_user_id", res.data.usuario.id);
      localStorage.setItem("rn573_bool", res.data.usuario.administrador);
      this.user = res.data.usuario;
      return this.user;
    },

    async fetchUser() {
      const res = await api.get('usuarios/me');
      this.user = res.data;
    },

    async logout() {
      await api.post("auth/logout");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_id");
      this.user = null;
    },

    async refreshToken() {
      const refreshToken = localStorage.getItem("rn573_refresh_token");
      if (!refreshToken) {
        throw new Error("Refresh token não encontrado.");
      }
      const res = await api.post("auth/refresh", { refreshToken });
      localStorage.setItem("rn573_access_token", res.data.access_token);
      return res.data.access_token;
    }
  },
   persist: true
});
